/* eslint-disable react/jsx-no-bind */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../actions/accountActions';
import MetaTags from 'react-meta-tags';
import * as qs from 'query-string';
import * as browserCheck from '../../utils/browserCheck.js';
import ErrorMessage from '../common/ErrorMessage';
import MaterialInput from '../common/MaterialInput';

class ForgotPasswordPage extends React.Component {
    constructor(props, context) {
        super(props, context);       
        this.forgotPassword = this.forgotPassword.bind(this);
        let email; 
        if(this.props.location.search) {
            const params = qs.parse(this.props.location.search);
            if(params.email) {
                //+'s in the email get replaces with spaces so swap it back
                email = params.email.trim().replace(/ /g,'+');
            }
        }        
        this.state = {     
            email,
            emailSent: false,
            submitting: false
        };         
    }

    componentWillMount() {
    }

    componentDidMount() {  
        if (browserCheck.canUseDom()) {
            window.componentHandler.upgradeDom(); 
        }    
    }

    forgotPassword(event) {
        event.preventDefault();
        this.setState({ submitting: true });
        this.props.actions.forgotPassword(this.state.email)
            .then(_ => {                
                this.setState({ emailSent: true, submitting: false });
            })
            .catch(error => {
                this.setState({ error: error.message, submitting: false });
            });
    }

    render() {
        return (            
            this.props.user ?
                <Redirect to="/" />
                :
                <div className="main">
                    <MetaTags>
                        <title>Forgotten Password - LoudUp</title>
                        <meta id="description" name="description" content="If you have forgotten your LoudUp password, you can reset it here" />
                        <meta id="robots" name="robots" content="noindex" />
                    </MetaTags> 
                    <div className="container">
                        <div className="block-inner">
                            <div className="row">
                                <div className="col-md-12">
                                    <article className="body-copy">
                                        <header>
                                            <h1 className="section-alt">Forgotten Password</h1>
                                        </header>
                                        <form className="form-regular minimal-height" onSubmit={this.forgotPassword}>
                                            {
                                                this.state.emailSent ?
                                                    <div className="alert alert-success">Please check your email and click on the link provided to reset your password. The link will be valid for the next 24 hours.</div>
                                                : 
                                                    <div className="col-sm-6 col-sm-push-3">
                                                        <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                                                        <p className="text-center">Please enter your e-mail address and click on confirm and we will send you an email which will contain instructions for resetting your password</p>
                                                        <br />
                                                        <MaterialInput name="Email" type="email" value={this.state.email} onChange={(event) => this.setState({ email: event.target.value })} />
                                                        <div className="form-group">
                                                            <input className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" type="submit" value="Confirm" disabled={this.state.submitting} />
                                                            &nbsp;
                                                            <Link to="/Account/Login" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--dark mdl-button--wide" type="button">Cancel</Link>
                                                        </div>
                                                    </div>
                                            }                                            
                                        </form>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>      
                </div>                    
        );
    }
}

ForgotPasswordPage.propTypes = {
    user: PropTypes.object,
    actions: PropTypes.object.isRequired,
    location: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return { user: state.account.user };
}

function mapDispatchToProps(dispatch) {
    return {
        //account actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, accountActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);